// import React, {
//   useEffect,
//   useState,
//   useCallback,
//   forwardRef,
//   useImperativeHandle,
//   useRef,
// } from "react";
// import {
//   MapContainer,
//   TileLayer,
//   Marker,
//   Popup,
//   Circle,
//   useMapEvents,
//   useMap,
//   GeoJSON,
// } from "react-leaflet";
// import VisibilityIcon from "@mui/icons-material/Visibility";
// import HideSourceSharpIcon from "@mui/icons-material/HideSourceSharp";
// import GpsFixedIcon from "@mui/icons-material/GpsFixed";
// import "leaflet/dist/leaflet.css";
// import L from "leaflet";
// import { IconButton, Tooltip } from "@mui/material";
// import useWebSocket from "../../pages/useWebSocket";
// // import { VehicleDemoFollowCoordinates } from "@/app/interfaces/commont";
// // import { PositionTest } from "@/app/services/notifications-service";
// // import * as shapefile from "shapefile"; // Importar shapefile

// // Configurar el ícono de Leaflet
// const DefaultIcon = L.icon({
//   iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
//   iconUrl: require("leaflet/dist/images/marker-icon.png"),
//   shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
// });

// L.Marker.prototype.options.icon = DefaultIcon;

// interface MapProps {
//   showFirstIcon?: boolean;
//   initialPosition?: [number, number];
//   zoom?: number;
//   radius?: number;
//   selectPos?: boolean;
//   height?: string;
//   handleChangePos?: (position: [number, number]) => void;
//   shapefileUrl?: string;
//   addIconFunc?: (icon: any) => void;
//   positionButtton?: boolean;
// }

// export interface MapImperativeHandle {
//   addMarker: (marker: any) => void;
// }

// const ClickableMap: React.FC<{
//   setPosition: (pos: [number, number]) => void;
// }> = ({ setPosition }) => {
//   useMapEvents({
//     click(e) {
//       setPosition([e.latlng.lat, e.latlng.lng]);
//     },
//   });
//   return null;
// };

// function LocateButton({ setPosition }: any) {
//   const map = useMap();

//   const handleClick = () => {
//     if (navigator.geolocation) {
//       navigator.geolocation.getCurrentPosition((position) => {
//         const { latitude, longitude } = position.coords;
//         setPosition([latitude, longitude]);
//         map.flyTo([latitude, longitude], 13); // Cambia el zoom a 13 o el nivel que prefieras
//       });
//     } else {
//       alert("Geolocation is not supported by this browser.");
//     }
//   };

//   return (
//     <Tooltip title={"Obtener mi ubicación actual"} placement="right-start">
//       <IconButton
//         onClick={handleClick}
//         style={{
//           position: "absolute",
//           bottom: "10px",
//           right: "10px",
//           zIndex: 1000,
//         }}
//         aria-label="delete"
//       >
//         <GpsFixedIcon />
//       </IconButton>
//     </Tooltip>
//   );
// }

// const Map = forwardRef<MapImperativeHandle, MapProps>(
//   (
//     {
//       initialPosition,
//       radius,
//       selectPos = false,
//       height = "200px",
//       handleChangePos,
//       shapefileUrl = "",
//       zoom = 17,
//       showFirstIcon = true,
//       positionButtton,
//     },
//     ref
//   ) => {
//     useImperativeHandle(ref, () => ({
//       addMarker(element: any) {
//         setActualPosition(element.position);

//         if (!markerList.find((marker: any) => marker.id === element.id))
//           setMarkerList((prev: any[]) => prev.concat([element]));
//       },
//     }));

//     const [sensorAvailableList, setSensorAvailableList]: any[] = useState([]);

//     const addSensorToViewer = (sensor: { id: any; position: any }) => {
//       setSensorAvailableList((prev: any[]) => {
//         const sensorIndex = prev.findIndex(
//           (element) => element.id === sensor.id
//         );

//         if (sensorIndex !== -1) {
//           const updatedList = [...prev];
//           updatedList[sensorIndex] = {
//             ...updatedList[sensorIndex],
//             position: sensor.position,
//           };
//           return updatedList;
//         } else {
//           return prev.concat({ id: sensor.id, position: sensor.position });
//         }
//       });
//     };

//     const onMessageReceived = (data: any) => {
//       const [latitude, longitude] = data.message
//         .split(",")
//         .map((coord: string) => parseFloat(coord.trim()));
//       const payload = {
//         id: data.id,
//         position: [latitude, longitude],
//       };
//       addSensorToViewer(payload);
//     };

//     const { sendMessage } = useWebSocket({
//       url: `wss://dprn7r3yj2.execute-api.us-east-1.amazonaws.com/production/`,
//       onMessage: onMessageReceived,
//       onError: (event) => console.error("WebSocket Error:", event),
//       onClose: (event) => {
//         setSensorAvailableList([]);
//         console.log("WebSocket Closed:", event);
//       },
//       onOpen: () => console.log("WebSocket Opened"),
//     });

//     const [markerList, setMarkerList]: any[] = useState([]);
//     const [position, setPosition] = useState<[number, number]>(
//       initialPosition || [9.930983221796705, -84.10216146385498]
//     );
//     const [actualPosition, setActualPosition] = useState(position);

//     const handlePositionChange = useCallback(
//       (pos: [number, number]) => {
//         setPosition(pos);
//         if (handleChangePos) {
//           handleChangePos(pos);
//         }
//       },
//       [handleChangePos]
//     );

//     const [geoJsonData, setGeoJsonData] = useState(null);

//     //////

//     const [currentIndex, setCurrentIndex] = useState(0);
//     // const vehiclePath = VehicleDemoFollowCoordinates;

//     const carIcon = L.icon({
//       iconUrl:
//         "https://garbage-collector-resources.s3.amazonaws.com/delivery-location_16991192.png", // Ruta al icono personalizado
//       iconSize: [24, 24], // Tamaño del icono [ancho, alto]
//       iconAnchor: [0, 0], // Punto donde se anclará el icono
//       popupAnchor: [0, -38], // Punto donde se abrirá el popup
//     });

//     const myPoint = L.icon({
//       iconUrl: "https://garbage-collector-resources.s3.amazonaws.com/gps.png", // Ruta al icono personalizado
//       iconSize: [32, 32], // Tamaño del icono [ancho, alto]
//       iconAnchor: [0, 10], // Punto donde se anclará el icono
//       popupAnchor: [15, -10], // Punto donde se abrirá el popup
//     });

//     useEffect(() => {
//       if (shapefileUrl) {
//         fetch(shapefileUrl)
//           .then((response) => response.json())
//           .then((data) => {
//             setGeoJsonData(data);
//           })
//           .catch((error) => {
//             console.error("Error al cargar el archivo GeoJSON:", error);
//           });
//       }

//       // addSensorToViewer({
//       //   id: "test1",
//       //   position: [10.005083859163491, -84.63012556257254],
//       // });
//     }, []);

//     return (
//       <MapContainer
//         center={position}
//         zoom={zoom}
//         style={{ height: height, width: "100%" }}
//       >
//         <TileLayer
//           url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
//           attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
//         />

//         {sensorAvailableList.map((marker: any) => (
//           <Marker key={marker.id} icon={carIcon} position={marker.position}>
//             <Popup>Marker {marker.id}</Popup>
//           </Marker>
//         ))}

//         {markerList.map((marker: any) => (
//           <Marker key={marker.id} icon={myPoint} position={marker.position}>
//             <Popup>
//               <strong>{marker.name}</strong>
//               <IconButton>
//                 <HideSourceSharpIcon />
//               </IconButton>
//             </Popup>
//           </Marker>
//         ))}

//         {position && showFirstIcon && (
//           <>
//             <Marker icon={myPoint} position={position}>
//               <Popup>
//                 Marker at position [{position[0]}, {position[1]}]
//               </Popup>
//             </Marker>
//             {radius && <Circle center={position} radius={radius} />}
//           </>
//         )}
//         {selectPos && <ClickableMap setPosition={handlePositionChange} />}

//         {geoJsonData && (
//           <GeoJSON
//             data={geoJsonData}
//             style={() => ({
//               color: "#05a5bf",
//               weight: 5,
//             })}
//             onEachFeature={(feature: any, layer: any) => {
//               if (feature.properties && feature.properties.name) {
//                 layer.bindPopup(feature.properties.name);
//               }
//             }}
//           />
//         )}
//         <MoveMap zoom={zoom} position={actualPosition} />
//         {positionButtton && <LocateButton setPosition={setPosition} />}
//       </MapContainer>
//     );
//   }
// );

// function MoveMap({ position, zoom }: any) {
//   const map = useMap();

//   useEffect(() => {
//     if (position) {
//       map.flyTo(position, zoom); // Mueve el mapa a la nueva posición
//     }
//   }, [position]);

//   return null;
// }

// export default Map;

import React, {
  useEffect,
  useState,
  useCallback,
  forwardRef,
  useImperativeHandle,
  useRef,
} from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  Circle,
  useMapEvents,
  useMap,
  GeoJSON,
} from "react-leaflet";
import VisibilityIcon from "@mui/icons-material/Visibility";
import HideSourceSharpIcon from "@mui/icons-material/HideSourceSharp";
import GpsFixedIcon from "@mui/icons-material/GpsFixed";
import CenterFocusStrongIcon from "@mui/icons-material/CenterFocusStrong";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { IconButton, Tooltip } from "@mui/material";
import useWebSocket from "../../pages/useWebSocket";

// Icono base Leaflet
const DefaultIcon = L.icon({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});
L.Marker.prototype.options.icon = DefaultIcon;

interface MapProps {
  showFirstIcon?: boolean;
  initialPosition?: [number, number];
  zoom?: number;
  /** Radio del círculo de la posición "principal" (mi pos / selección) */
  radius?: number;
  selectPos?: boolean;
  height?: string;
  handleChangePos?: (position: [number, number]) => void;
  shapefileUrl?: string;
  addIconFunc?: (icon: any) => void;
  /** Botón para ir a mi ubicación */
  positionButtton?: boolean;
  /** Mostrar camiones en tiempo real via WebSocket */
  enableRealtime?: boolean;
}

export interface MapImperativeHandle {
  /** Agrega o actualiza un marcador y lo hace visible */
  addMarker: (marker: {
    id: string | number;
    name?: string;
    position: [number, number];
    radius?: number; // opcional por marcador
  }) => void;
  /** Quita completamente el marcador del mapa */
  removeMarker: (id: string | number) => void;
  /** Alterna visibilidad de un marcador existente */
  // setMarkerVisibility: (id: string | number, visible: boolean) => void;
  /** Vuela a una posición */
  flyTo: (pos: [number, number], z?: number) => void;
  /** Centra al punto inicial (props.initialPosition) */
  centerToInitial: () => void;
  /** Intenta ubicar mi posición actual y centrar */
  showMyLocation: () => void;
}

const ClickableMap: React.FC<{
  setPosition: (pos: [number, number]) => void;
}> = ({ setPosition }) => {
  useMapEvents({
    click(e) {
      setPosition([e.latlng.lat, e.latlng.lng]);
    },
  });
  return null;
};

function LocateButton({ setPosition }: any) {
  const map = useMap();

  const handleClick = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        const { latitude, longitude } = position.coords;
        const next: [number, number] = [latitude, longitude];
        setPosition(next);
        map.flyTo(next, 16);
      });
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  };

  return (
    <Tooltip title={"Obtener mi ubicación actual"} placement="right-start">
      <IconButton
        onClick={handleClick}
        style={{
          position: "absolute",
          bottom: "10px",
          right: "10px",
          zIndex: 1000,
        }}
        aria-label="locate"
      >
        <GpsFixedIcon />
      </IconButton>
    </Tooltip>
  );
}

function ResetViewButton({
  initialCenter,
}: {
  initialCenter: [number, number];
}) {
  const map = useMap();
  const handleReset = () => map.flyTo(initialCenter, map.getZoom());
  return (
    <Tooltip title="Centrar a la vista inicial">
      <IconButton
        onClick={handleReset}
        style={{
          position: "absolute",
          bottom: "58px",
          right: "10px",
          zIndex: 1000,
        }}
        aria-label="reset-view"
      >
        <CenterFocusStrongIcon />
      </IconButton>
    </Tooltip>
  );
}

const Map = forwardRef<MapImperativeHandle, MapProps>(
  (
    {
      initialPosition,
      radius,
      selectPos = false,
      height = "200px",
      handleChangePos,
      shapefileUrl = "",
      zoom = 17,
      showFirstIcon = true,
      positionButtton,
      enableRealtime = true,
    },
    ref,
  ) => {
    const initialCenter: [number, number] = initialPosition || [
      9.930983221796705, -84.10216146385498,
    ];

    const [markerList, setMarkerList] = useState<
      Array<{
        id: string | number;
        position: [number, number];
        name?: string;
        radius?: number;
        visible: boolean;
      }>
    >([]);

    const [sensorAvailableList, setSensorAvailableList]: any[] = useState([]);
    const [position, setPosition] = useState<[number, number]>(initialCenter);
    const [actualPosition, setActualPosition] = useState(position);
    const [geoJsonData, setGeoJsonData] = useState<any>(null);

    const carIcon = L.icon({
      iconUrl:
        "https://garbage-collector-resources.s3.us-east-1.amazonaws.com/Icono+camio%CC%81n.png",
      iconSize: [40, 30],
      iconAnchor: [20, 15],
      popupAnchor: [0, -16],
    });
    const specialCarIcon = L.icon({
      iconUrl:
        "https://garbage-collector-resources.s3.us-east-1.amazonaws.com/camion_recol_especial.png",
      iconSize: [56, 42],
      iconAnchor: [28, 21],
      popupAnchor: [0, -22],
    });

    const myPoint = L.icon({
      iconUrl: "https://garbage-collector-resources.s3.amazonaws.com/gps.png",
      iconSize: [32, 32],
      iconAnchor: [0, 10],
      popupAnchor: [15, -10],
    });

    useImperativeHandle(ref, () => ({
      addMarker(element) {
        setActualPosition(element.position);
        setMarkerList((prev) => {
          const exists = prev.find((m) => m.id === element.id);
          if (exists) {
            return prev.map((m) =>
              m.id === element.id
                ? {
                    ...m,
                    position: element.position,
                    name: element.name,
                    radius: element.radius,
                    visible: true,
                  }
                : m,
            );
          }
          return prev.concat([{ ...element, visible: true }]);
        });
      },
      removeMarker(id) {
        setMarkerList((prev) => prev.filter((m) => m.id !== id));
      },
      // setMarkerVisibility(id, visible) {
      //   setMarkerList((prev) =>
      //     prev.map((m) => (m.id === id ? { ...m, visible } : m))
      //   );
      // },
      flyTo(pos, z) {
        setActualPosition(pos);
        setPosition(pos);
      },
      centerToInitial() {
        setActualPosition(initialCenter);
        setPosition(initialCenter);
      },
      showMyLocation() {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition((pos) => {
            const next: [number, number] = [
              pos.coords.latitude,
              pos.coords.longitude,
            ];
            setActualPosition(next);
            setPosition(next);
          });
        }
      },
    }));

    const addSensorToViewer = (sensor: { id: any; position: any }) => {
      setSensorAvailableList((prev: any[]) => {
        const i = prev.findIndex((e) => e.id === sensor.id);
        if (i !== -1) {
          const updated = [...prev];
          updated[i] = { ...updated[i], position: sensor.position };
          return updated;
        }
        return prev.concat({ id: sensor.id, position: sensor.position });
      });
    };

    const onMessageReceived = (data: any) => {
      console.log(data, 222);
      const [latitude, longitude] = data.message
        .split(",")
        .map((coord: string) => parseFloat(coord.trim()));
      addSensorToViewer({ id: data.id, position: [latitude, longitude] });
    };

    useWebSocket({
      url: `wss://dprn7r3yj2.execute-api.us-east-1.amazonaws.com/production/`,
      onMessage: onMessageReceived,
      onError: (event) => console.error("WebSocket Error:", event),
      onClose: (event) => {
        setSensorAvailableList([]);
        console.log("WebSocket Closed:", event);
      },
      onOpen: () => console.log("WebSocket Opened"),
      enabled: enableRealtime,
    });

    useEffect(() => {
      if (!enableRealtime) {
        setSensorAvailableList([]);
      }
    }, [enableRealtime]);

    const handlePositionChange = useCallback(
      (pos: [number, number]) => {
        setPosition(pos);
        if (handleChangePos) handleChangePos(pos);
      },
      [handleChangePos],
    );

    useEffect(() => {
      if (shapefileUrl) {
        fetch(shapefileUrl)
          .then((response) => response.json())
          .then((data) => setGeoJsonData(data))
          .catch((error) =>
            console.error("Error al cargar el GeoJSON:", error),
          );
      }
    }, [shapefileUrl]);

    return (
      <MapContainer
        center={position}
        zoom={zoom}
        style={{ height, width: "100%" }}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />

        {/* Trackers en tiempo real */}
        {enableRealtime &&
          sensorAvailableList.map((marker: any) => {
            const isSpecialTruck = String(marker.id) === "SM007918";
            return (
              <Marker
                key={marker.id}
                icon={isSpecialTruck ? specialCarIcon : carIcon}
                position={marker.position}
              >
                <Popup>Camión recolector {marker.id}</Popup>
              </Marker>
            );
          })}

        {/* Marcadores de usuario (toggleables) */}
        {markerList
          .filter((m) => m.visible)
          .map((marker: any) => (
            <React.Fragment key={marker.id}>
              <Marker icon={myPoint} position={marker.position}>
                <Popup>
                  <strong>{marker.name || `Point ${marker.id}`}</strong>
                  <IconButton>
                    <HideSourceSharpIcon />
                  </IconButton>
                </Popup>
              </Marker>
              {/* Radio propio por marcador */}
              {typeof marker.radius === "number" && marker.radius > 0 && (
                <Circle center={marker.position} radius={marker.radius} />
              )}
            </React.Fragment>
          ))}

        {/* Posición principal (mi pos / selección) */}
        {position && showFirstIcon && (
          <>
            <Marker icon={myPoint} position={position}>
              <Popup>
                Marker at position [{position[0]}, {position[1]}]
              </Popup>
            </Marker>
            {radius && <Circle center={position} radius={radius} />}
          </>
        )}

        {selectPos && <ClickableMap setPosition={handlePositionChange} />}

        {geoJsonData && (
          <GeoJSON
            data={geoJsonData}
            style={() => ({ color: "#05a5bf", weight: 5 })}
            onEachFeature={(feature: any, layer: any) => {
              if (feature.properties && feature.properties.name) {
                layer.bindPopup(feature.properties.name);
              }
            }}
          />
        )}

        {/* Sincroniza movimientos */}
        <MoveMap zoom={zoom} position={actualPosition} />

        {/* Botones de UI */}
        {positionButtton && <LocateButton setPosition={setPosition} />}
        <ResetViewButton initialCenter={initialCenter} />
      </MapContainer>
    );
  },
);

function MoveMap({ position, zoom }: any) {
  const map = useMap();
  useEffect(() => {
    if (position) map.flyTo(position, zoom);
  }, [position, zoom, map]);
  return null;
}

export default Map;
